<div class="placeholder">
    @switch (data.type) {
        @case ("info") {
            <mat-icon class="info">check_circle</mat-icon>
        }
        @case ("warn") {
            <mat-icon class="warn">warning</mat-icon>
        }
        @case ("error") {
            <mat-icon class="error">error</mat-icon>
        }
        }
    <div [innerHTML]="data.msg"></div>
</div>